import { useQuery } from '@tanstack/react-query';
import portalApi from 'utils/portalApi';

const getActivityActualStartTime = async (activityId) => {
    const { data } = await portalApi.get(`api/activity/${activityId}/actualStartTime`);
    return data;
};

const useActivityActualStartTime = (activityId) => {
    const { data, refetch, isLoading } = useQuery({
        queryKey: ['activityStartTime', activityId],
        queryFn: () => getActivityActualStartTime(activityId),
        staleTime: 2000
    });

    return { data, refetch, isLoading };
};

export default useActivityActualStartTime;
